import { sendYandexMetrika } from "./main2021";
export var TARIFF_TYPE = {
  fttb: 'fttb',
  conv: 'conv'
};
var tariffTypeYM = {
  _type: TARIFF_TYPE.fttb,
  set: function set(type) {
    this._type = type;
  },
  get value() {
    return this._type;
  }
};

/** Все клики на страницах ШПД */
export var tariffClickYM = function tariffClickYM() {
  return sendYandexMetrika(tariffTypeYM.value === TARIFF_TYPE.fttb ? 'HomeTariffConnect' : 'ConvergentTariffConnect', {
    URL: document.location.href
  });
};

/** Клики на форму обратного звонка на ШПД */
export var callbackFormClickYM = function callbackFormClickYM(isIcon, isConvergent) {
  return sendYandexMetrika(isConvergent ? 'ConvergentTariffCallbackShortForm' : 'HomeTariffCallbackForm', {
    URL: document.location.href,
    form_type: isIcon ? 'icon' : 'popup'
  });
};

/** Клики на техническую поддержку ШПД */
export var technicalSupportClickYM = function technicalSupportClickYM(isConvergent) {
  return sendYandexMetrika(isConvergent ? 'ConvergentTariffTechQuestion' : 'HomeTariffTechQuestion', {
    URL: document.location.href
  });
};
export var longFormSubmitNewYM = function longFormSubmitNewYM(orderId) {
  return sendYandexMetrika('ConvergentTariffCallbackLongFormNew',
  // eslint-disable-next-line camelcase
  {
    tariff_convergent_request_dm_: orderId
  });
};
export var longFormSubmitExistYM = function longFormSubmitExistYM(orderId) {
  return sendYandexMetrika('ConvergentTariffCallbackLongFormExist',
  // eslint-disable-next-line camelcase
  {
    tariff_convergent_request_dm_: orderId
  });
};